import { axios } from '../axios';
function getConfig(_a) {
    var _b = _a.requestTimeout, requestTimeout = _b === void 0 ? 0 : _b, clientId = _a.clientId, apiUrlCampaignsConfig = _a.apiUrlCampaignsConfig, jsonFileName = _a.jsonFileName;
    return axios({
        method: 'GET',
        url: "".concat(apiUrlCampaignsConfig, "/rmccx/").concat(clientId, "/").concat(jsonFileName, ".json"),
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        timeout: requestTimeout,
    });
}
export function getJsonConfig(_a) {
    var requestTimeout = _a.requestTimeout, clientId = _a.clientId, apiUrlCampaignsConfig = _a.apiUrlCampaignsConfig, jsonFileName = _a.jsonFileName;
    return getConfig({
        clientId: clientId,
        requestTimeout: requestTimeout,
        apiUrlCampaignsConfig: apiUrlCampaignsConfig,
        jsonFileName: jsonFileName,
    });
}
